// extracted by mini-css-extract-plugin
export default {"root":"TextField_root__U8uJT","label":"TextField_label__airGZ","errorLabel":"TextField_errorLabel__vl3Zc","footerLabel":"TextField_footerLabel__Y1cf0"};